import { Link, useLocation, useNavigate } from 'react-router-dom'
import { AnnouncementBanner } from '../common/AnnouncementBanner'
import { Search } from '../common/Search'
import { MenuIcon } from '../icons'
import { useIsFetching } from '@tanstack/react-query'
import LoadingSpinner from '../common/LoadingSpinner'
import { useAuth } from '../../contexts/AuthContext'
import { NotificationDropdown } from '../common/NotificationDropdown'
import { UserIcon } from '@heroicons/react/24/outline'
import { IGNORE_LOADING_QUERY_KEYS, QueryKeys } from '../../utils/queryKeyGenerator'

export const HeaderActions = () => {
  const { isAuthenticated, currentUser } = useAuth()

  return (
    <div className="flex items-center">
      {isAuthenticated() ? (
        <>
          <NotificationDropdown />
          <div className="relative group flex">
            <button className="flex items-center space-x-2 p-2 hover:bg-neutral-200-100 rounded-md transition-colors">
              <div className="relative">
                <UserIcon className="w-5 h-5 sm:w-6 sm:h-6 text-icon-default" />
              </div>
              <span className="font-inter text-sm sm:text-base font-medium text-foreground hidden sm:inline">
                {currentUser?.name || 'User'}
              </span>
            </button>
          </div>
        </>
      ) : (
        <div className="relative">
          <Link
            to="/login"
            className="flex items-center space-x-2 px-3 py-2 hover:bg-neutral-200-100 rounded-md transition-colors group"
          >
            <UserIcon className="w-5 h-5 sm:w-6 sm:h-6 text-icon-default" />
            <span className="font-inter text-sm sm:text-base font-medium text-foreground">
              Get Started
            </span>
          </Link>
          <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-secondary-600 scale-x-0 group-hover:scale-x-100 transition-transform duration-200"></div>
        </div>
      )}
    </div>
  )
}

export const Header = ({ setMenuOpen }) => {
  const isFetching = useIsFetching({
    predicate: (query) => {
      if (IGNORE_LOADING_QUERY_KEYS.includes(query.queryKey[0])) {
        return false
      }

      return true
    },
  })

  const location = useLocation()
  const navigate = useNavigate()

  let placeholder = 'Search...'
  let searchContext = 'global'

  if (location.pathname.startsWith('/products')) {
    placeholder = 'Search For Products'
    searchContext = 'products'
  } else if (location.pathname.startsWith('/retailers')) {
    placeholder = 'Search a retailer'
    searchContext = 'retailers'
  } else if (location.pathname.startsWith('/wholesalers')) {
    placeholder = 'Search a wholesaler'
    searchContext = 'wholesalers'
  }

  const handleGlobalSearch = (searchTerm) => {
    if (!searchTerm.trim()) return

    navigate(`/search?q=${encodeURIComponent(searchTerm)}&context=${searchContext}`)
  }

  return (
    <>
      <div className="h-28 lg:h-20"></div>
      <div className="fixed top-0 left-0 right-0 z-30 bg-background ">
        <div className="w-full mx-auto  bg-header-bg">
          <AnnouncementBanner />
          <header className=" border-b border-secondary-600 shadow-header">
            <div className="pb-3  max-w-[1400px] mx-auto">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3 sm:space-x-4 h-8 sm:h-10 md:h-12">
                  <button
                    onClick={() => setMenuOpen(true)}
                    className="p-2 hover:bg-neutral-200-100 rounded-md transition-colors"
                    aria-label="Open Menu"
                  >
                    <MenuIcon className="w-5 h-5 sm:w-6 sm:h-6 text-icon-default" />
                  </button>
                  <Link to="/" className="flex items-center">
                    <img
                      src="/eastsoko-logo.png"
                      alt="EastSoko"
                      className="h-8 w-auto object-contain"
                    />
                    {isFetching > 0 && <LoadingSpinner size="20px" className="ml-3" />}
                  </Link>
                </div>
                <div className="flex-1 mx-4 hidden lg:block">
                  <Search placeholder={placeholder} onSearch={handleGlobalSearch} />
                </div>

                <HeaderActions />
              </div>

              <div className="mt-3 lg:hidden mx-2">
                <Search placeholder={placeholder} onSearch={handleGlobalSearch} />
              </div>
            </div>
          </header>
        </div>
      </div>
    </>
  )
}
